<template>
  <div>
    <Mainlayout></Mainlayout>

    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="mt-5">
            <CCard
              v-for="item in AnswerList"
              v-bind:key="item.quizId"
              style="
                background-color: #e6f0ff;
                border-color: #80b3ff;
                border-radius: 20px;
              "
              class="col-12"
            >
              <CRow class="text-left mt-3">
                <CCol class="col-10">
                  <p>
                    <strong
                      >Question {{ item.questionNum }}:
                      <span v-html="item.question"> </span></strong
                    >
                  </p>
                </CCol>
                <CCol class="col-2 text-right">
                  <div v-if="qSummary.IsPublish === false">
                    <CButton @click="GoToPageEditQuiz(item.questionId)">
                      <img
                        src="../assets/img/edit.png"
                        width="20px"
                        height="20px"
                      />
                    </CButton>
                  </div>
                </CCol>
              </CRow>

              <div
                class="col-12 text-center"
                v-if="item.questionImagePath != null"
              >
                <CRow class="justify-content-center">
                  <CCard
                    style="background: #ffffff; border: #000000"
                    class="box-shadow"
                    @click="
                      ViewFullImage(
                        item.questionFolderName,
                        item.questionImageName
                      )
                    "
                  >
                    <img class="image" :src="getPic(item)" />
                  </CCard>
                </CRow>
              </div>

              <p style="margin-bottom: 0px" v-if="item.choiceA != null">
                A. {{ item.choiceA }}
              </p>
              <p style="margin-bottom: 0px" v-if="item.choiceB != null">
                B. {{ item.choiceB }}
              </p>
              <p style="margin-bottom: 0px" v-if="item.choiceC != null">
                C. {{ item.choiceC }}
              </p>
              <p style="margin-bottom: 0px" v-if="item.choiceD != null">
                D. {{ item.choiceD }}
              </p>
              <p style="margin-bottom: 0px" v-if="item.choiceE != null">
                E. {{ item.choiceE }}
              </p>
              <p style="margin-bottom: 0px" v-if="item.choiceF != null">
                F. {{ item.choiceF }}
              </p>
              <p style="margin-bottom: 0px" v-if="item.choiceG != null">
                G. {{ item.choiceG }}
              </p>
              <br />
            </CCard>

            <!-- published -->
            <div v-if="qSummary.IsPublish === true">
              <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToPageQuizList"
              >
                Close
              </CButton>
            </div>

            <!-- pending -->
            <div v-else>
              <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToPageCreateQuestion(quizTitleId)"
              >
                Add Question
              </CButton>

              <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="PublishQuiz"
              >
                Publish
              </CButton>
         
            </div>
          </CCol>
        </CContainer> <br /><br />
      </CCol>
    </CCard>
    <CModal class="col-12" :show.sync="ViewImageModal">
      <CRow class="justify-content-center">
        <CCard>
          <img class="imageFull" :src="getPicFull()" />
        </CCard>
      </CRow>
      <template class="modal-footer" hidden="true" #footer>
        <span></span>
      </template>
    </CModal>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebTutor.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      AnswerList: [],
      qSummary: {},
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false,
      ViewImageModal: false,
      //isDisabled: "",
    };
  },
  async mounted() {
    this.GetQuesDetails();
    this.GetQuizPreview();
  },
  computed: {},
  methods: {
    //Get details question
    async GetQuesDetails() {
      return this.$API
        .get(this.$ListQuestion + "?quizId=" + this.$route.query.quizId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.AnswerList = response.data;
            console.log("AnswerList", this.AnswerList);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Get quiz summary
    async GetQuizPreview() {
      this.$API
        .get(this.$QuizPreview + "?quizId=" + this.$route.query.quizId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    
    //Page Quiz List
    GoToPageQuizList() {
      this.$router.push(
        "/QuizTeacherQuizList?userId=" +
          this.qSummary.userId +
          "&subjectId=" +
          this.qSummary.SubjectId
      );
    },
    //Edit Question
    GoToPageEditQuiz(questionId) {
      this.$router.push(
        "/QuizTeacherEditQuestion?questionId=" +
          questionId +
          "&quizId=" +
          this.$route.query.quizId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    //Add Question
    GoToPageCreateQuestion(quizTitleId) {
      this.$router.push(
        "/QuizTeacherCreateQuestion?quizTitleId=" +
          this.$route.query.quizId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    //publish Quiz
    PublishQuiz() {
      // if (this.Question !== "") {
      //   this.CreateQuestion();
      // }
      const formData = new FormData();
      formData.append("quizId", this.$route.query.quizId);
      console.log("try")

      return this.$API
        .post(this.$PublishQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.GoToPageQuizList();
          
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
            console.log(error.response.data);
          }
        });
    },
    
    //Image
    ViewFullImage(questionFolderName, questionImageName) {
      this.getPicFull(questionFolderName, questionImageName);
      console.log("testing" + questionFolderName + questionImageName);

      this.ViewImageModal = true;

      this.foldername = questionFolderName;
      this.imagename = questionImageName;

      this.getPicFull(this.foldername);
    },
    getPic(AnswerList) {
      return (
        "https://pickiddo.com/Quiz/" +
        AnswerList.questionFolderName +
        "/" +
        AnswerList.questionImageName
      );
    },

    getPicFull() {
      console.log("testing1" + this.foldername + this.imagename);
      return (
        "https://pickiddo.com/Quiz/" + this.foldername + "/" + this.imagename
      );
    },
  },
};
</script>


<style>
.image {
  object-fit: none;
  object-position: center;
  font-family: "object-fit: none; object-position: center;";
}

.imageFull {
  object-fit: fill;
  object-position: center;
  font-family: "object-fit: fill; object-position: center;";
}

#fb-root{
  display:none;
}
</style>